/**
 * Created by sara on 2/8/16.
 */

(function () {
    'use strict';

    // @ngInject
    function SentFirstOnboardingFileModalControllerCtor($modalInstance, $state, AppStates, AnalyticsService, OnboardingService, workspaceId, eventId, fileType) {

        this.$modalInstance = $modalInstance;
        this.__objectType = 'SentFirstOnboardingFileModalController';
        this.$state = $state;
        this.AppStates = AppStates;
        this.workspaceId = workspaceId;
        this.eventId = eventId;
        this.OnboardingService = OnboardingService;
        this.imageSource = 'https://s3.amazonaws.com/honeybook_cdn/assets_system/system_web/main_general/alexis-thumb.jpg';

        AnalyticsService.trackPageView(this, 'onboarding sent first proposal modal');
    }

    Controllers.SentFirstOnboardingFileModalController = Class(Controllers.BaseController, {
        constructor: SentFirstOnboardingFileModalControllerCtor,

        close: function close() {
            this.$modalInstance.close();
        },

        changeActive: function changeActive(tab) {
            var oldTab = this.activeTab;
            this.activeTab = tab.title;
        },

        goToWorkspace: function goToWorkspace() {
            this.$state.go(this.AppStates.root_core_navigation_event_workspace_files, {workspace_id: this.workspaceId, event_id: this.eventId});
            this.$modalInstance.close();
        }

    });
}());